import React from 'react'

import { getStationCalculationIndicesHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItem } from 'store/directorySlice'

const useGetCSCalculationIndices = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetPipeTypes = async () => {
    await getStationCalculationIndicesHandbook().then((res) => {
      dispatch(setDirectoryItem(res.data))
    })
  }

  React.useEffect(() => {
    tryToGetPipeTypes().then()
  }, [requestData])

  return
}

export default useGetCSCalculationIndices
